module.exports = __webpack_public_path__ + "static/media/king-must-dine.87257795.png";